import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 209,
	height: 35,
	viewBox: "0 0 209 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_414_661)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M28.7734 5.59961H0.982422V33.5885H28.7734V5.59961Z",
				fill: "#1DCA6C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M180.973 5.59961V33.5885H187.085V22.666H202.705V33.5885H208.818V5.59961H180.973ZM202.705 16.5221H187.085V11.7435H202.705V16.5221Z",
				fill: "#222222"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48.177 11.7435V16.5221H69.5703V33.5885H42.0645V27.4446H63.7977V22.666H42.0645V5.59961H69.5703V11.7435H48.177Z",
				fill: "#222222"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M104.063 5.59961V22.666H82.3295V33.5885H76.2168V16.5221H97.9502V11.7435H76.2168V5.59961H104.063Z",
				fill: "#222222"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M138.215 16.5234H110.709V22.6672H138.215V16.5234Z",
				fill: "#222222"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M138.215 27.4453H110.709V33.5892H138.215V27.4453Z",
				fill: "#222222"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M138.215 5.59961H110.709V11.7435H138.215V5.59961Z",
				fill: "#222222"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M155.577 27.4446H173.913V33.5885H146.068V5.59961H152.181V21.9833L167.122 5.59961H174.932L155.577 27.4446Z",
				fill: "#222222"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.90076 25.6442L9.92869 31.1561L9.17519 24.642L14.952 18.1279L21.2312 24.642L19.9753 31.1561L25.7521 25.6442V17.6269L16.7101 1.3418L9.17519 12.3655V7.85584L3.39844 17.6269L3.90076 25.6442Z",
				fill: "#222222"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_414_661",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 208,
			height: 33.0543,
			fill: "white",
			transform: "translate(0.886719 0.972656)"
		})
	}) })]
});
export default SvgLogo1;
